export default {
  baseUrl: import.meta.env.VITE_APP_BASE_API,
  SSOUrl: '',
  bookUrl: import.meta.env.VITE_APP_READER_API,
  bookUrlTeacher: import.meta.env.VITE_APP_TEACHER_READER_API,
  tokenKey: 'STUDENT_TOKEN',
  tokenTeacherKey: 'TEACHER_TOKEN',
}
